import { ArraySchema, MapSchema } from "@colyseus/schema";

const GameStates = {
    Loading: "loading",
    Tutorial: "tutorial",
    Idle: "idle",
    SelectTeamMethod: "select_team_method",
    SelectTeams: "select_teams",
    ConfirmTeams: "confirm_teams",
    PlayingIdle: "playing_idle",
    Playing: "playing",
    RuleBreakVote: "rule_break_vote",
    CorrectCardVote: "correct_card_vote",
    NewRuleVote: "new_rule_vote",

    GameOver: "game_over",
    EndGame: "end_game",
};

const testRoomState = {
    room: {
        send: (message, data) => {
            console.log(`Room.send: ${message}`, data);
        }
    },
    gameState: GameStates.Loading,
    requiredPlayers: 4,
    roundNumber: 0,
    timer: 60,
    timerRunning: false,
    teamSelectionType: "random",
    teams: [
        {
            id: "Team A",
            playerIds: ["1", "2"],
            colour: "pink",
            score: 7,
            currentCards: [],
            totalRuleBreaks: 0,
            totalCorrectPairs: 0,
            rules: [
                {
                    id: "RULE-Default",
                    ruleText1: "You Can't say",
                    blockText: "Umm",
                    ruleText2: "",
                }
            ],
        },
        {
            id: "Team B",
            playerIds: ["3", "4"],
            colour: "black",
            score: 18,
            currentCards: [],
            totalRuleBreaks: 0,
            totalCorrectPairs: 0,
            rules: [
                {
                    id: "RULE-Default",
                    ruleText1: "You Can't say",
                    blockText: "Umm",
                    ruleText2: "",
                }
            ],
        }
    ],
    describingTeamId: "Team A",
    currentRuleBreaks: 0,
    currentCorrectPairIds: [],
    newRuleTeamId: "",
    currentValidationNum: 0,
    currentRulesVote: [],
    pointsToWin: 20,
    dangerZoneStart: 15,
    newRuleZones: [5, 10],
    winningTeamId: "",
    clientDescriberState: "_DEFAULT",


    players: [
        {
            name: "WWWWWWWWWW",
            id: "1",
            avatar: 1,
            primaryPlayer: true,
            ycsuData: {
                teamIndex: 0,
                isDescriber: true,
                isDinger: false,
                ready: false,
                beenDescriber: false,
                beenDinger: false,
                currentRuleVoteId: "",
            },
        },
        {
            name: "Player 2",
            id: "2",
            avatar: 2,
            ycsuData: {
                teamIndex: 0,
                isDescriber: false,
                isDinger: false,
                ready: false,
                beenDescriber: false,
                beenDinger: false,
                currentRuleVoteId: "",
            },
        },
        {
            name: "Player 3",
            id: "3",
            avatar: 3,
            ycsuData: {
                teamIndex: 1,
                isDescriber: false,
                isDinger: true,
                ready: false,
                beenDescriber: false,
                beenDinger: false,
                currentRuleVoteId: "",
            },
        },
        {
            name: "Player 4",
            id: "4",
            avatar: 4,
            ycsuData: {
                teamIndex: 1,
                isDescriber: false,
                isDinger: false,
                ready: false,
                beenDescriber: false,
                beenDinger: false,
                currentRuleVoteId: "",
            },
        }
    ],

}

export {
    testRoomState,
};